/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_traffic_deviation__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ignorieren`
};

const en_traffic_deviation__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ignore`
};

const es_traffic_deviation__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ignorar`
};

const fr_traffic_deviation__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ignorer`
};

const it_traffic_deviation__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ignora`
};

const nl_traffic_deviation__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Negeren`
};

const pt_traffic_deviation__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Ignorar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const traffic_deviation__cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.traffic_deviation__cta(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("traffic_deviation__cta", locale)
	if (locale === "de") return de_traffic_deviation__cta(inputs)
	if (locale === "en") return en_traffic_deviation__cta(inputs)
	if (locale === "es") return es_traffic_deviation__cta(inputs)
	if (locale === "fr") return fr_traffic_deviation__cta(inputs)
	if (locale === "it") return it_traffic_deviation__cta(inputs)
	if (locale === "nl") return nl_traffic_deviation__cta(inputs)
	return pt_traffic_deviation__cta(inputs)
};